import { ImportWizardPage } from '@/portal/src/dataSources/ImportWizardPage';
import type { PortalBootstrapData } from './types/window';
import type { PortalSearchSyncFn } from './utils/portalUrlState';

type CompanyImportFromProvidersPageProps = {
  navigateTo: (path: string) => void;
  bootstrap: PortalBootstrapData;
  companyId: number | null;
  onSessionExpired: () => void;
  search?: string;
  patchPortalSearch?: PortalSearchSyncFn;
};

const CompanyImportFromProvidersPage = ({
  navigateTo,
  bootstrap,
  companyId,
  onSessionExpired,
  search,
  patchPortalSearch,
}: CompanyImportFromProvidersPageProps) => {
  return (
    <ImportWizardPage
      navigateTo={navigateTo}
      bootstrap={bootstrap}
      companyId={companyId}
      onSessionExpired={onSessionExpired}
      search={search}
      patchPortalSearch={patchPortalSearch}
    />
  );
};

export default CompanyImportFromProvidersPage;
